import React from "react";
import { ColumnValueRendererProps, LinkColumnValue } from "../table.data.interface";
import { Tooltip } from "@vibe/core";
import { sanitizeUrl } from "../../../utils/security/sanitizeUrl";

const LinkColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    (!columnData.text && isPreview) ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const value = otherBoardsValues
    ? (columnData?.value as LinkColumnValue)?.text
    : isPreview
      ? columnData?.text
      : (columnData?.value as string);

  const url = otherBoardsValues
    ? (columnData?.value as LinkColumnValue)?.url
    : isPreview
      ? columnData?.value
      : (columnData?.value as string);

  if (isPreview) {
    return (
      <div className="overflow-hidden whitespace-nowrap text-ellipsis">
        <Tooltip content={value}>
          <span>{value}</span>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <a
        href={sanitizeUrl(url as string)}
        target="_blank"
        rel="noreferrer"
        className="no-underline cursor-pointer hover:underline"
      >
        {value}
      </a>
    </div>
  );
};

export default LinkColumn;
